import React from 'react';
import styles from '../styles/CardButton.module.css';

interface CardButtonProps {
    imagePath: string;
    buttonText: string;
}

const CardButton: React.FC<CardButtonProps> = ({imagePath, buttonText}) => {
    return (
        <div className={styles.container}>
            <img src={imagePath} alt='image-card' className={styles.image}></img>
            <button className={styles.button}>{buttonText}</button>
        </div>
    );
};

export default CardButton;